import { render } from "./TariffRules.vue?vue&type=template&id=9413d9f4&scoped=true"
import script from "./TariffRules.vue?vue&type=script&lang=js"
export * from "./TariffRules.vue?vue&type=script&lang=js"

import "./TariffRules.vue?vue&type=style&index=0&id=9413d9f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9413d9f4"]])

export default __exports__